import { IntlContextProvider, IntlProvider } from 'gatsby-plugin-intl';
import React from 'react';
import { allMessages } from './intl-utils';

type Locale = 'de' | 'en' | 'fr';

interface IntlWrapperProps {
  locale: Locale;
  originalPath?: string;
  children: React.ReactNode;
}

/**
 * Shared IntlProvider wrapper for both production and Storybook.
 * Provides both IntlContextProvider (for gatsby-plugin-intl hooks) and IntlProvider (for react-intl).
 */
export const IntlWrapper = ({ locale, originalPath = '/', children }: IntlWrapperProps) => {
  const messages = allMessages[locale] || allMessages.de;

  const intlConfig = {
    language: locale,
    languages: ['de', 'en', 'fr'] as Locale[],
    messages,
    originalPath,
    redirect: false,
    routed: true,
  };

  return (
    <IntlContextProvider value={intlConfig}>
      <IntlProvider locale={locale} defaultLocale='de' messages={messages}>
        {children}
      </IntlProvider>
    </IntlContextProvider>
  );
};
